import { render, staticRenderFns } from "./IconLive.vue?vue&type=template&id=51565908&scoped=true"
import script from "./IconLive.vue?vue&type=script&lang=js"
export * from "./IconLive.vue?vue&type=script&lang=js"
import style0 from "./IconLive.vue?vue&type=style&index=0&id=51565908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51565908",
  null
  
)

export default component.exports